/** Pixel di Meta "pixel martial arts it" (copia italiana: Italia e Svizzera/Ticino). Mai il pixel della versione inglese, tedesca o francese.
 *  PageView al caricamento, ViewContent quando si vede la sezione dell'offerta, InitiateCheckout SOLO sul pulsante dell'offerta. */
export const META_PIXEL_ID = '975090402319706';
